<app-sidebar-header [showBackButton]="true" (backButtonClicked)="goBack()">
  <div smallTitle>{{ packageId() ? 'Edit ' : 'Add ' }} Submittal Package</div>
  <div mainTitle class="flex justify-between items-center">
    <div>REGISTRY ITEMS</div>
    <span
      (click)="removeAllRegistryItems()"
      class="icon-trash-x cursor-pointer text-size_icon_bigger text-red-600"
    ></span>
  </div>
</app-sidebar-header>
<ng-scrollbar #scrollbar class="std-scrollbar flex-1" [appearance]="'compact'" orientation="vertical">
  <div class="flex flex-col flex-1">
    <form #registryItemsForm="ngForm" role="form">
      <div class="flex flex-col my-3 mx-7">
        @for (item of model().registry_items; track item.id; let itemIndex = $index) {
          <div class="flex items-center gap-2">
            <app-dropdown
              [required]="true"
              class="w-full"
              [ngModel]="item.id"
              (ngModelChange)="onRegistryItemChange($event, itemIndex)"
              [name]="'registry_item_name_' + itemIndex"
              [label]="'Registry Item  ' + (itemIndex + 1)"
              [placeholder]="'Registry Item  ' + (itemIndex + 1)"
              optionLabel="spec_description"
              optionValue="id"
              [options]="registryItemOptions()"
              [disabledOptionIds]="disabledRegistryItemIds()"
              [isLoading]="registryItemsLoading()"
              [enablePagination]="true"
              [isPaginationLoading]="loadingMoreRegistryItems()"
              (loadMoreOptions)="loadMoreRegistryItemOptions()"
            >
              <ng-template #selectedContent #optionContent let-option>
                <div class="flex flex-col">
                  <span class="text-size_xl font-semibold">
                    {{ option.spec_section }} {{ option.spec_description }}
                  </span>
                  <span class="text-size_l font-normal">{{ option.item_description }}</span>
                </div>
              </ng-template>
            </app-dropdown>

            <app-add-remove-buttons
              class="mt-4"
              [disabledRemove]="model()?.registry_items?.length === 1"
              [disabledAdd]="model()?.registry_items?.length >= registryItemOptions()?.length"
              (removeItem)="removeRegistryItem(itemIndex)"
              (addItem)="addRegistryItem(itemIndex)"
            >
            </app-add-remove-buttons>
          </div>
        }
      </div>
    </form>
  </div>
</ng-scrollbar>

<div class="mt-auto border-b border-b-solid border-navy-300"></div>

<div class="my-6 mx-7 flex justify-between items-center gap-4">
  <div class="text-navy-900 text-sm font-bold">Total Registry Items</div>
  <div class="text-navy-900 text-sm font-bold">
    {{ registryItemCount() }}
  </div>
  <app-simple-button buttonStyle="color_accent_filled" (click)="submitForm()">
    @if (model().id) {
      Update
    } @else {
      Create
    }
  </app-simple-button>
</div>
